export default {
    getLogsFHEPool: (fromDate, toDate) => {
        return {
            url: '/logs/env/:env',
            method: 'GET',
            route_params: {
                env: 'fhepool'
            },
            get_params: {
                fromDate,
                toDate
            }
        };
    }
};



// WEBPACK FOOTER //
// ./environments/logging/data/LogsFHEPool/api.js